/**
 * 容量告警阈值下限最小值
 */
export const ALARM_CAPACITY_LOWER_MIN = 1;

/**
 * 容量告警阈值下限最大值
 */
export const ALARM_CAPACITY_LOWER_MAX = 95;

/**
 * 容量告警阈值上限最小值
 */
export const ALARM_CAPACITY_UPPER_MIN = 2;

/**
 * 容量告警阈值上限最大值
 */
export const ALARM_CAPACITY_UPPER_MAX = 99;

/**
 * 保护容量阈值下限最小值
 */
export const PROTECTION_CAPACITY_LOWER_MIN = 1;

/**
 * 保护容量阈值下限最大值
 */
export const PROTECTION_CAPACITY_LOWER_MAX = 95;

/**
 * 保护容量阈值上限最小值
 */
export const PROTECTION_CAPACITY_UPPER_MIN = 2;

/**
 * 保护容量阈值上限最大值
 */
export const PROTECTION_CAPACITY_UPPER_MAX = 99;

/**
 * 默认热备策略
 */
export const DEFAULT_HOT_SPARE = -1;

/**
 * 默认全闪存储池起配盘数
 */
export const DEFAULT_PERFORMANCE_DISK_NUM = 8;

/**
 * 热备盘数量枚举
 */
export enum HotSpareCountE {
    NONE = 0,
    LOW = 1,
    HIGH = 2,
    CUSTOM_3 = 3,
    CUSTOM_4 = 4,
    CUSTOM_5 = 5,
    CUSTOM_6 = 6,
    CUSTOM_7 = 7,
    CUSTOM_8 = 8
}

/**
 * 热备盘数量与热备策略的映射关系
 */
export const HOT_SPARE_COUNT_AND_POLICY_MAP = {
    /**
     * 低/高/无 热备场景，热备策略枚举值含义：1：低（1盘） 2：高（2盘） 3：无
     */
    [HotSpareCountE.NONE]: 3,
    [HotSpareCountE.LOW]: 1,
    [HotSpareCountE.HIGH]: 2,
    /**
     * 热备策略枚举值 >=4 为自定义数量场景：热备策略枚举值 - 4 = 对应的热备盘数
     * 例如 7-4=3，则 枚举值7 的热备策略表示“自定义3块”;
     * 例如 5-4=1，则 枚举值5 的热备策略表示“低（1盘）”（没有在此定义，因为已经定义了枚举值1）
     */
    [HotSpareCountE.CUSTOM_3]: 7,
    [HotSpareCountE.CUSTOM_4]: 8,
    [HotSpareCountE.CUSTOM_5]: 9,
    [HotSpareCountE.CUSTOM_6]: 10,
    [HotSpareCountE.CUSTOM_7]: 11,
    [HotSpareCountE.CUSTOM_8]: 12,
};

/**
 * 【新增容量自动按照扩容前配额占比分配给关联存储池】开关状态枚举
 */
export enum AutoAllocQuotaTypeE {
    OFF = '0',
    ON = '1'
}

/**
 * 扩容性能层下发参数
 */
export interface ExpandSmartPoolParams {
    id?: string | number;
    diskNumList?: Array<string>;
    diskCapacityList?: Array<string>;
    engineIdList?: Array<string>;
    name?: string;
    autoAllocQuotaType?: string;
    diskNum?: string;
    associateObjIDList?: Array<string>;
    hotSpareStrategy?: string;
    enableDataEncryption?: number;
    frameIdList?: Array<string>;
}
